import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import {CommonModal} from 'components/common';
import ClassroomTable from './ClassroomTable';
import ClassroomCreation from './ClassroomCreation';
import UserClassroomAddition from '../School/UserClassroomAddition';
import MoveUserToClassroomForm from './MoveUserToClassroomForm';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {
  fetchClassrooms,
  setCurrentClassroomPage,
  setCurrentClassroom,
  clearClassroomsAfterPage,
} from 'actions/classrooms';
import {removeUserFromClassroom} from 'api/classrooms';
import {canManageSchool, isKluwellAdmin, isSchoolCoordinator, isTeacher, isReader} from 'utils/permissions';

class ClassroomList extends React.Component {
  static propTypes = {
    classroomPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      createClassroomModalShown: false,
      addUserToClassroomsModalShown: false,
      moveUserToClassroomsModalShown: false,
      refreshTableKey: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.removeUserFromClassroom = this.removeUserFromClassroom.bind(this);
  }

  showModal(type) {
    this.setState({
      [`${type}ModalShown`]: true,
    });
  }

  closeModal() {
    this.setState({
      createClassroomModalShown: false,
      addUserToClassroomsModalShown: false,
      moveUserToClassroomsModalShown: false,
    });
  }

  handleSuccess() {
    this.setState((prevState) => ({
      createClassroomModalShown: false,
      addUserToClassroomsModalShown: false,
      moveUserToClassroomsModalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
  }

  removeUserFromClassroom(record) {
    const {user, addFlashMessage, formatErrors} = this.props;
    return removeUserFromClassroom(record.id, user.id)
      .then(() => {
        this.setState((prevState) => ({
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
        addFlashMessage('User has been successfully removed from the classroom!', 'success');
      })
      .catch((err) => formatErrors(err));
  }

  render() {
    const {
      createClassroomModalShown,
      addUserToClassroomsModalShown,
      moveUserToClassroomsModalShown,
      refreshTableKey,
    } = this.state;
    const {
      me,
      user,
      classroomPages,
      fetchClassrooms,
      setCurrentClassroomPage,
      setCurrentClassroom,
      clearClassroomsAfterPage,
      hiddenFields,
    } = this.props;
    const userId = isEmpty(user) ? undefined : user.id;
    const canManageUserClassrooms =
      !isEmpty(user) &&
      (isKluwellAdmin(me.role) ||
        (isSchoolCoordinator(me.role) &&
          (isSchoolCoordinator(user.role) || isTeacher(user.role) || isReader(user.role))) ||
        (isTeacher(me.role) && isReader(user.role)));
    const schoolId = !isEmpty(me.activeSchool) ? me.activeSchool.id : null;
    return (
      <React.Fragment>
        {!userId ? (
          <CommonModal title="Create New Classroom" onClose={this.closeModal} show={createClassroomModalShown}>
            <ClassroomCreation schoolId={schoolId} onSubmitSuccess={this.handleSuccess} />
          </CommonModal>
        ) : (
          <React.Fragment>
            <CommonModal title="Add User to Classrooms" onClose={this.closeModal} show={addUserToClassroomsModalShown}>
              <UserClassroomAddition userId={userId} schoolId={schoolId} onSubmitSuccess={this.handleSuccess} />
            </CommonModal>
            <CommonModal
              title="Move User to Another Classroom"
              onClose={this.closeModal}
              show={moveUserToClassroomsModalShown}
            >
              <MoveUserToClassroomForm userId={userId} onSubmitSuccess={this.handleSuccess} />
            </CommonModal>
          </React.Fragment>
        )}
        <div className="container content-box">
          <Panel>
            {!userId ? (
              <h3 className="section-header">
                <div className="section-title">Classrooms</div>
                {canManageSchool(me.role) && (
                  <Button
                    variant="contained"
                    color="primary"
                    className="pull-right"
                    onClick={() => this.showModal('createClassroom')}
                  >
                    Create Classroom
                  </Button>
                )}
              </h3>
            ) : (
              <h3 className="section-header">
                <div className="section-title">User's Classrooms</div>
                {canManageUserClassrooms &&
                  (!isReader(user.role) ? (
                    <Button
                      variant="contained"
                      color="primary"
                      className="pull-right"
                      onClick={() => this.showModal('addUserToClassrooms')}
                    >
                      Add User to Classrooms
                    </Button>
                  ) : (
                    isKluwellAdmin(me.role) && (
                      <Button
                        variant="contained"
                        color="primary"
                        className="pull-right"
                        onClick={() => this.showModal('moveUserToClassrooms')}
                      >
                        Move user to another classroom
                      </Button>
                    )
                  ))}
              </h3>
            )}
            <ClassroomTable
              {...{
                refreshTableKey,
                recordPages: classroomPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchClassrooms(q, page, perPage, sortOpts, {...extraFilters, summary: true, userId}),
                setCurrentRecordPage: setCurrentClassroomPage,
                setCurrentRecord: setCurrentClassroom,
                clearRecordsAfterPage: clearClassroomsAfterPage,
                onDeleteActionClick: canManageUserClassrooms ? this.removeUserFromClassroom : undefined,
                hiddenFields: hiddenFields || (!isEmpty(me.activeSchool) ? ['schoolName'] : undefined),
                extraFiltersEnabled: true,
              }}
            />
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  ({account, classrooms}) => ({
    me: account.get('user').toJS(),
    classroomPages: classrooms.get('classroomPages').toJS(),
  }),
  {
    addFlashMessage,
    formatErrors,
    fetchClassrooms,
    setCurrentClassroomPage,
    setCurrentClassroom,
    clearClassroomsAfterPage,
  },
)(ClassroomList);
